import { StatusTone } from "./statusTone.utils";

/** Invoice statuses as the backend and ops frontend write them. */
export enum InvoiceStatus {
  DRAFT = "Draft",
  SENT = "Sent",
  PARTIALLY_PAID = "Partially Paid",
  READY_FOR_BILLING = "Ready for Billing",
  PAID = "Paid",
}

// Anything not listed (Draft included) stays neutral.
export const INVOICE_STATUS_TONES: Partial<Record<InvoiceStatus, StatusTone>> = {
  [InvoiceStatus.SENT]: StatusTone.ACTIVE,
  [InvoiceStatus.READY_FOR_BILLING]: StatusTone.ACTIVE,
  [InvoiceStatus.PAID]: StatusTone.DONE,
  [InvoiceStatus.PARTIALLY_PAID]: StatusTone.EXCEPTION,
};

// Invoice statuses arrive with mixed casing and separators ("ready_for_billing", "Ready For Billing").
const normalise = (status: string) => status.toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();

export const invoiceStatusTone = (status?: string | null): StatusTone => {
  if (!status) return StatusTone.NEUTRAL;
  const match = Object.values(InvoiceStatus).find((known) => normalise(known) === normalise(status));
  return (match && INVOICE_STATUS_TONES[match]) ?? StatusTone.NEUTRAL;
};
